import { useContext, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Avatar from '../../atoms/Avatar/Avatar';
import ErrorAlert from '../../atoms/ErrorAlert/ErrorAlert';
import LabelledInput from '../../atoms/LabelledInput/LabelledInput';
import Spinner from '../../atoms/Spinner/Spinner';
import WideButton from '../../atoms/WideButton/WideButton';
import GlobalVariablesContext from '../../contexts/GlobalVariablesContext';
import './LoginForm.scss';

const LoginForm = () => {

    const { giftsApi, setAccount } = useContext(GlobalVariablesContext);

    const [authenticating, setAuthenticating] = useState(false);

    const [userName, setUserName] = useState('');

    const [password, setPassword] = useState('');

    const [error, setError] = useState('');

    const navigate = useNavigate();

    const [getParameters] = useSearchParams();

    const handleLoginButtonClick = async () => {
        setAuthenticating(true);
        setError('');
        await giftsApi
            .login({
                userName: userName,
                password: password
            })
            .then(data => {
                localStorage.setItem('gifts.user', JSON.stringify(data.data));
                setAccount(data.data);

                let returnUrl = getParameters.get('returnUrl');
                if (returnUrl !== null && returnUrl.startsWith('/gifts/')) {
                    returnUrl = returnUrl.substring(7);
                }
                navigate(returnUrl !== null && returnUrl !== '' ? returnUrl : '/home');
            })
            .catch(error => {
                setAuthenticating(false);
                setError(error.response.data.error);
            });
    }

    return (
        <form method="post">
            <div className="login-avatar">
                <Avatar />
            </div>

            {error !== '' && <ErrorAlert title="Cannot Login" message={error} />}

            {authenticating
                ?
                <Spinner />
                :
                <>
                    <LabelledInput name="userName" label="Username or Email Address:" placeholder="Enter Username or Email Address" required={true} value={userName} onChange={e => setUserName(e.target.value)} />
                    <LabelledInput name="password" type="password" label="Password:" placeholder="Enter Password" required={true} value={password} onChange={e => setPassword(e.target.value)} />
                    <WideButton label="Login" submits={true} onClick={() => handleLoginButtonClick()} />
                </>
            }
        </form>
    )
}

export default LoginForm;